<div class="contact-item">
  <lib-contact-avatar alias="{{ alias() }}" [count]="count()"></lib-contact-avatar>
  <ion-label class="contact-name">{{ alias() }}&nbsp;</ion-label>
  @if (role()) {
    <ion-label class="contact-role">{{ role() }}</ion-label>
  }
</div>
